import {Operation} from '../../operation/operations/operation.model';

export class OperationUtils {

  public static isOperationAmountCredited(operation: Operation): boolean {

    if (operation.operationType === 'CREDIT') {
      return true;
    }

    if (operation.operationType === 'DEPOT_COLLECT') {
      return true;
    }

    if (operation.operationType === 'TRANSFERT' &&
      operation.sendingOperation !== null && operation.sendingOperation !== undefined) {
      return true;
    }

    return false;
  }

  public static isOperationAmountDebited(operation: Operation): boolean {

    if (operation.operationType === 'DEBIT') {
      return true;
    }

    if (operation.operationType === 'TRANSFERT' &&
      (operation.sendingOperation === null || operation.sendingOperation === undefined) ) {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/utils/OperationUtils.ts